import { TFunction } from 'react-i18next'

export interface TracksTableProps {
  t: TFunction<'translation'>
}

export enum TabKeys {
  new = 'new',
  in_progress = 'in_progress',
  awaiting = 'awaiting',
  completed = 'completed',
  canceled = 'canceled',
}
